import moment from "moment";
import qs from "qs";

import { ACTIVE_STATUS,LeadSystemLookUp, TaskSystemLookUp } from "./constant";
import { COUNTRY_CODE_LIST } from "./countryCodes";
import axiosInstance from "../api/axiosInstance";

export const getToken = () => localStorage.getItem('accessToken');

const getConfig = (isFile = false) => ({
    headers: {
        "Content-Type": isFile
            ? "multipart/form-data"
            : "application/json",
    },
});

export const getQueryStrinngFromObject = (data) => {
    const obj = {}
    Object.entries(data).map(([key, value]) => {
        if(value) {
            obj[key] = value;
        }
    });

    return Object.entries(obj).map(([k, v]) => `${k}=${encodeURIComponent(v)}`).join("&");
}

export const getElasticFormatedFromObject = (data, type) => {
    
    const obj = {}
    

    Object.entries(data).map(([key, value]) => {
        if(value) {
            obj[key] = value;
        }
    });

    const formatedObj = {
        "documentType" : type,
        "searchWith" : obj,
        "operator" : "AND"
    }

    return formatedObj;
    
}


export const requestDeleteApiCall = async(url) => {
    

    try {
        const response = await axiosInstance.delete(url,getConfig());
        return response;
    } catch (error) {
        return error;
    }
    
}

export const getOrderRequestData = async(url) => {
    
    try {
        const response = await axiosInstance.get(url, getConfig());
        return response;
    } catch(error) {
        // return error;
        return  { propererror: error?.response, status: 'error'}
    }
}
 
export const getRequestData = async (url) => {
    
    try {
        const response = await axiosInstance.get(url, getConfig());
        return response;
    } catch(error) {
        return error;
    }
}

export const getRequestDataWithoutToken = (url) => {
    
    try {
        const response = axiosInstance.get(url, getConfig());
        return response;
    } catch(error) {
        return error;
    }
}

export const createOrderRequestData = async (data, url, isFile=false) => {
    
    try {
        const response = await axiosInstance.post(url,data, getConfig(isFile));
        return response;
    } catch(error) {
        return  { propererror: error?.response, status: 'error'}
    }
}


export const updateOrderRequestData = async(data, url) => {
    
    try {
        const response = await axiosInstance.put(url,data,  getConfig());
        return response;
    } catch(error) {
        // return error;
        return  { propererror: error?.response, status: 'error'}
    }
}


export const createRequestData = async (data, url, isFile=false) => {
    
    try {
        const response = await axiosInstance.post(url,data, getConfig(isFile));
        return response;
    } catch(error) {
        return  { propererror: error?.response, status: 'error'}
    }
}

export const updateRequestData = async (data, url, isFile=false) => {

    try {
        const response = await axiosInstance.put(url,data,  getConfig(isFile));
        return response;
    } catch(error) {
        return  { propererror: error?.response, status: 'error'}
    }
}


export const searchRequestData = async (queryparams, url, isFile=false) => {

    try {
        const response = await axiosInstance.get(url,{   ...getConfig(isFile), ...queryparams});
        return response;
    } catch(error) {
        return  { propererror: error?.response, status: 'error'}
    }
}

export const putRequest = async (url, params) => {
  try {
    return await axiosInstance.put(url, null, {
      params,
      paramsSerializer: p =>
        qs.stringify(p, { arrayFormat: "repeat" }),
      headers: {
        "Authorization": `Bearer ${localStorage.getItem("accessToken")}`,
      },
    });
  } catch (error) {
    return { error: error?.response };
  }
};

export const dateFormatting =(date)=>{
return moment(date).format("YYYY-MM-DD")
}
export const dateFormattingForShowing =(date)=>{
return moment(date).format("MM-DD-YYYY")
}

export const isValidEmail = (email)=>{
const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
return regex.test(email)
}

export const isValidPhoneNumber = (value, phoneCountryCode = "+91") => {
  const strValue = String(value || "").trim();

  if (!strValue) return false;

  const countryConfig =
    COUNTRY_CODE_LIST.find((c) => c.countryCode === phoneCountryCode) ||
    COUNTRY_CODE_LIST.find((c) => c.countryCode === "+91");

  if (!countryConfig?.length) return false;

  return (
    /^[0-9]+$/.test(strValue) &&
    strValue.length === countryConfig.length
  );
};

//To check if pocName is non-empty
const isNonEmpty = (value) => typeof (value === "string") && value?.trim()?.length > 0;

const pocPhoneEmailCheck = (userDetail) => {
  const phoneValid = !userDetail?.pocPhone || userDetail.pocPhone.length === 0 ? true : isValidPhoneNumber(userDetail.pocPhone,userDetail?.pocPhoneCountryCode);
  const emailValid = !userDetail?.pocEmail || userDetail.pocEmail.length === 0 ? true : isValidEmail(userDetail.pocEmail);
  return phoneValid && emailValid
};

//To check validity of poc Values
const pocPhoneEmailNonEmptyCheck = (userDetail) => {
  const phoneValid = isValidPhoneNumber(userDetail?.pocPhone || "");
  const emailValid = isValidEmail(userDetail?.pocEmail || "");
  const firtNameValid = isNonEmpty(userDetail?.pocFirstName);
  const lastNameValid = isNonEmpty(userDetail?.pocLastName);

  return phoneValid && emailValid && firtNameValid && lastNameValid;
};

//Phone and email non-empty check
const phoneEmailNonEmptyCheck = (userDetail) => {
  const phoneValid = !userDetail?.phone || userDetail.phone.length === 0 ? true : isValidPhoneNumber(userDetail.phone,userDetail?.phoneCountryCode);
  const emailValid = isValidEmail(userDetail?.email || "");
  const altPhoneValid = !userDetail?.altPhone || userDetail.altPhone.length === 0 ? true : isValidPhoneNumber(userDetail.altPhone,userDetail?.altPhoneCountryCode);

  return phoneValid && emailValid && altPhoneValid;
};



//To check if client while creation and updation have valid mandatory values.
export const clientValidation = (userDetail) => {
  return (
    isNonEmpty(userDetail?.clientCode) &&
    isNonEmpty(userDetail?.name) &&
    isNonEmpty(userDetail?.tradeName) &&
    isNonEmpty(userDetail?.constitutionOfBusiness) &&
    phoneEmailNonEmptyCheck(userDetail) &&
    pocPhoneEmailCheck(userDetail)
  );
};

export const userValidation = (userDetail)=>{
    return (
    isNonEmpty(userDetail?.title) &&
    isNonEmpty(userDetail?.firstName) &&
    isNonEmpty(userDetail?.lastName) &&
    isNonEmpty(userDetail?.status) &&
    userDetail?.selectedCompany &&
    userDetail?.validFrom &&
    userDetail?.validTo &&
    phoneEmailNonEmptyCheck(userDetail)
    )
}

export const validateFields = (config, data) => {
  const errors = {};

  Object.entries(config || {}).forEach(([fieldKey, field]) => {
    if (field?.mandatory && field?.visibility) {
      const value = data?.[fieldKey];

      let isEmpty = false;

      if (value === undefined || value === null) {
        isEmpty = true;
      } else if (typeof value === "string") {
        isEmpty = value.trim() === "";
      } else if (Array.isArray(value)) {
        isEmpty = value.length === 0;
      } else if (typeof value === "object") {
        isEmpty = Object.keys(value).length === 0;
      }

      errors[fieldKey] = isEmpty;
    }
  });
    const emailFields = ["email", "altEmail", "pocEmail"];

    emailFields.forEach((emailField) => {
    const emailValue = data?.[emailField];

    if (!emailValue) {
        errors[emailField] = errors[emailField] || false;
        return;
    }

    errors[emailField] = !isValidEmail(emailValue);
    });
  const phoneFields = [
    {
      phoneField: "phone",
      countryCodeField: "phoneCountryCode",
    },
    {
      phoneField: "altPhone",
      countryCodeField: "altPhoneCountryCode",
    },
    {
      phoneField: "pocPhone",
      countryCodeField: "pocPhoneCountryCode",
    },
  ];

  phoneFields.forEach(({ phoneField, countryCodeField }) => {
    const phoneValue = data?.[phoneField];
    const phoneCountryCode = data?.[countryCodeField] || "+91";

    if (!phoneValue) {
      errors[phoneField] = errors[phoneField] || false;
      return;
    }

    errors[phoneField] = !isValidPhoneNumber(phoneValue, phoneCountryCode);
  });

  const hasError = Object.values(errors).some(Boolean);

  return { errors, hasError };
};

export const customerValidation = (userDetail)=>{
    return (
    isNonEmpty(userDetail?.title) &&
    isNonEmpty(userDetail?.firstName) &&
    isNonEmpty(userDetail?.lastName) &&
    isNonEmpty(userDetail?.status) &&
    phoneEmailNonEmptyCheck(userDetail)&&
    pocPhoneEmailCheck(userDetail)
)}

    export const getEntityList = (inputSearch) => {

        var entitiesList = [];

        if(inputSearch?.entity == "LEAD_SIDEBAR_MENU") {
            
            entitiesList = ["Lead","LeadFollowup","LeadProduct","LeadDocument"];
        
        }

        if(inputSearch?.entity == "CUSTOMER_SIDEBAR_MENU") {
            
            
            entitiesList = ["Customer","CustomerProduct","CustomerDocument"];
        
        }

        if(inputSearch?.entity == "SALES_ORDER_SIDEBAR_MENU") {
            
            entitiesList = ["SalesOrder", "SalesOrderProduct"];
        
        }

        if(inputSearch?.entity == "INVOICE_SIDEBAR_MENU") {
            
            entitiesList = ["Invoice", "InvoiceProduct"];
        
        }

        if(inputSearch?.entity == "VENDOR_SIDEBAR_MENU" || inputSearch?.entity == "MERCHANT_SIDEBAR_MENU") {
            
            entitiesList = ["Vendor","VendorDocument"];
        
        }

        if(inputSearch?.entity == "PRODUCT_SIDEBAR_MENU") {
                
            entitiesList = ["Product","ProductDocument"];
        
        }

        if(inputSearch?.entity == "CONF_MENU_USER") {
                
            entitiesList = ["User","UserRole"];
        
        }

        if(inputSearch?.entity == "CONF_MENU_CLIENT") {
                
            entitiesList = ["Client"];
        
        }

        if(inputSearch?.entity == "TEMPLATE_SIDEBAR_MENU") {
                
            entitiesList = ["Template","TemplateAttachment"];
        
        }

        if(inputSearch?.entity == "TASKS_SIDEBAR_MENU") {
                
            entitiesList = ["Task", "TaskActivity","TaskDocument"];
        
        }

        return entitiesList;
}

export const handleCellEditStart = () => {
    setTimeout(() => {
      const input = document.querySelector('.MuiDataGrid-cell--editing');
      if (input) {
        input.focus(); 
        const length = input.value.length;
        input.setSelectionRange(length, length); 
      }
    }, 10);

}

export const downloadDocument = async (documentId) => {
  try {
    const response = await getDocumentBlob(documentId)
    const disposition = response.headers["content-disposition"];
    const contentType = response.headers["content-type"];
    
    
    let filename = "file";
    
    if (disposition) {
      const exactMatch = disposition.match(/filename="([^"]*)"/);
      if (exactMatch && exactMatch[1]) {
        filename = exactMatch[1];
      }else {
        const parts = disposition.split('filename=');
        if (parts.length > 1) {
          filename = parts[1].replace(/^"|"$/g, '').split(';')[0].trim();
        }
      }
    }

    const blobUrl = window.URL.createObjectURL(
      new Blob([response.data], { type: contentType })
    );
    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    setTimeout(() => {
      window.URL.revokeObjectURL(blobUrl);
    }, 100);
    
    return true;
  } catch (error) {
    return false;
  }
};
export const getDocumentAsBlobUrl = async (documentId) => {
  if (!documentId) return null;
  try {
    const response = await getDocumentBlob(documentId)
    const blob = response.data;
    const contentType = response.headers["content-type"] || blob.type || "application/octet-stream";
    const blobUrl = window.URL.createObjectURL(new Blob([blob], { type: contentType }));
    return blobUrl;
  } catch (err) {
    return null;
  }
}

export const getDocumentBlob = (documentId) => {
  return axiosInstance.get(
    `${process.env.REACT_APP_BASE_URL}documents/download/${documentId}`,
    {
      responseType: "blob",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
    }
  );
}

export const handleOpenInNewTab = (url) => {
  return  window.open(url, '_blank', 'noopener,noreferrer');
}

export const renderLeadStatus = (systemCode) => {
        
        let style = {
            backgroundColor: "black",
            color: 'white',
            width: '100%'
        }
        switch(systemCode) {

            case LeadSystemLookUp?.LEAD_STATUS_PROSPECT:
                style.backgroundColor = "#79B1CC";
                style.color = "black";
                break;
            case LeadSystemLookUp?.LEAD_STATUS_OPEN:
                style.backgroundColor = "#B5FCCD";
                style.color = "black";
                break;
            case LeadSystemLookUp?.LEAD_STATUS_DEAL_CLOSED:
                style.backgroundColor = "#1434C9";
                style.color = "white";
                break;
            case LeadSystemLookUp?.LEAD_STATUS_OVERRIDE:
                style.backgroundColor = "#4FC8F7";
                style.color = "black";
                break;
            case LeadSystemLookUp?.LEAD_STATUS_CANCELLED:
                style.backgroundColor = "#F07F92";
                style.color = "black";
                break;
        }

        return style;
    
}

export const renderTaskStatus = (systemCode) => {
        
        let style = {
            backgroundColor: "black",
            color: "white",
            width: '100%'
        }
        switch(systemCode) {

            case TaskSystemLookUp?.TASK_STATUS_CLOSED:
                style.backgroundColor = "#1434C9";
                style.color = "white";
                break;
            case TaskSystemLookUp?.TASK_STATUS_OPEN:
                style.backgroundColor = "#B5FCCD";
                style.color = "black";
                break;
            case TaskSystemLookUp?.TASK_STATUS_CANCELLED:
                style.backgroundColor = "#F07F92";
                style.color = "black";
                break;
            case TaskSystemLookUp?.TASK_STATUS_OVERRIDE:
                style.backgroundColor = "#4FC8F7";
                style.color = "black";
                break;
            case TaskSystemLookUp?.TASK_STATUS_WIP:
                style.backgroundColor = "#79B1CC";
                style.color = "black";
                break;
        }

        return style;
    
}

export const getActionableStatusStyle = (statusType, systemCode) => (
    statusType === 'lead' ? renderLeadStatus(systemCode) : renderTaskStatus(systemCode)
);

export const renderPriorityDesirabilityColor = (value) => {
    let style = {
        backgroundColor: "black",
        color: "white",
        width: '100%'
    }
    switch(value) {
        case "LEAD_DESIRABILITY_WARM":
        case "TASK_PRIORITY_MEDIUM":
            style.backgroundColor = "#79B1CC";
            style.color = "black";
            break;
        case "LEAD_DESIRABILITY_COLD":
        case "TASK_PRIORITY_LOW":
            style.backgroundColor = "#FFCC9C";
            style.color = "black";
            break;
        case "LEAD_DESIRABILITY_HOT":
        case "TASK_PRIORITY_HIGH":
            style.backgroundColor = "#B950CB";
            style.color = "white";
            break;
    }
    return style;
}
export const getEntityColumns = (allEntityData, entityName) => {
  if (!Array.isArray(allEntityData)) return {};

  const entity = allEntityData.find(
    (item) => item?.entityName === entityName
  );

  if (!entity?.columnJson) return {};

  const columnJson = entity.columnJson;

  // handle string JSON (important for your backend case)
  if (typeof columnJson === "string") {
    try {
      return JSON.parse(columnJson);
    } catch (e) {
      console.error("Invalid columnJson:", e);
      return {};
    }
  }

  return columnJson;
};

export const getAllowedValuesByEntity = (
    allEntityData,
    entityType,
    lookupType,
    clientLookupCode
) => {
    const entityData = allEntityData?.find(
        item => item?.entityName === entityType
    );

    const rule = entityData?.entityRuleEngineDTO?.find(
        item =>
            item?.lookupType === lookupType &&
            item?.clientLookupCode === clientLookupCode
    );

    const result = (rule?.allowedLookupCode ?? []).map(value => ({
        name: value
    }));

    return result;
};
export const getFieldError = (fieldKey, config, data) => {
  const fieldConfig = config?.[fieldKey];

  if (!fieldConfig) return false;

  const isMandatory = fieldConfig?.mandatory;
  const isVisible = fieldConfig?.visibility;
  const value = data?.[fieldKey];

  // Only validate if visible + mandatory
  if (isMandatory && isVisible) {
    return !value || value.toString().trim() === "";
  }

  return false;
};

export const getLookupType  = (data,type,status = ACTIVE_STATUS) => {
   return (
    data?.find((item) => item?.name === type)?.codes
      ?.filter((item) => item?.status === status)
      ?.slice()
      ?.sort((a, b) => a?.sequence - b?.sequence)
  ) || [];
}
